<template>
  <v-form v-model="valid">
    <v-dialog v-model="formulaDialog" max-width="900">
      <formula-generator v-if="formulaDialog" v-bind:formula="detail.formula" @save="setFormula" @cancel="closeFormulaDialog"></formula-generator>
    </v-dialog>

    <v-dialog v-model="deleteDialog" persistent max-width="320">
      <v-card>
        <v-card-title class="headline">{{$t('delete_component')}}</v-card-title>
        <v-card-text>{{$t('you_sure')}}</v-card-text>
        <v-card-actions class="pa-3">
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="deleteDialog = false">{{$t('cancel')}}</v-btn>
          <v-btn color="error" :loading="loading" @click="deleteComponent(detail)">{{$t('delete')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-card class="pt-3 container" tile flat>
      <v-tabs-items v-model="tab">
        <v-tab-item>
          <v-row>
            <v-col md="12">
              <v-card-title>
                <v-row>
                  <v-col cols="12">
                    <span class="headline">{{$t('component_items')}}</span>
                    <v-btn icon class="float-right" @click="close" v-if="showCloseButton">
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </v-col>
                  <v-col cols="12">
                    <v-switch
                      v-model="showAll"
                      inset
                      height="5"
                      class="mt-0 p-0 text-right"
                      color="success"
                     :label="$t('show_all')"
                      @change="refreshData()"
                    ></v-switch>
                  </v-col>
                </v-row>
              </v-card-title>
              <v-card-text>
                <v-data-table
                  :loading="loading"
                  :headers="headers"
                  :items="formData"
                  :footer-props="{ 'items-per-page-options': [10, 50, 100], 'items-per-page-text': $t('rows_per_page') }" 
                  :page="page"
                  :no-data-text="$t('no_data')"
                  @update:page="setPage($event)"
                  height="400px"
                >
                  <template v-slot:footer.page-text="items"> {{ items.pageStart }} - {{ items.pageStop }} {{$t('of')}} {{ items.itemsLength }} </template>
                  <template v-slot:item.no="{ index }">
                    <span v-if="page==1">{{(index+1)}}</span>
                    <span v-else>{{(index+1) + ((page-1)*10)}}</span>
                  </template>
                  <template v-slot:item.action="{item}">
                    <v-btn plain class="primary--text" @click="seeDetail(item)">{{$t('see_details')}}</v-btn>
                  </template>
                </v-data-table>
              </v-card-text>
            </v-col>
            <v-col md="12" class="pt-0" v-if="!disableAdd">
              <div class="sae-grey" @click="add">
                <v-icon class="ml-2">mdi-plus</v-icon>
                <span class="ml-4">{{$t('salary_component')}}</span>
              </div>
            </v-col>
          </v-row>
        </v-tab-item>

        <v-tab-item>
          <v-card-text>
            <v-row ref="form">
              <v-col md="6">
                <v-btn icon @click="tab = 0">
                  <v-icon>mdi-arrow-left</v-icon>
                </v-btn>{{$t('back')}}
              </v-col>
              <v-col md="6" class="text-right" v-if="isEdit && !disableAdd">
                <v-btn icon @click="deleteItem(detail)" color="error">
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
              </v-col>
              <v-col md="12" class="pb-0 pt-0">
                <v-autocomplete
                  v-model="detail.componentId"
                  :items="componentList"
                  hide-no-data
                  hide-selected
                  item-text="name"
                  item-value="id"
                 :label="$t('component')"
                  required
                  :rules="[...rules2, validator.alfaNumberNotRequired]"
                  class="sae-required"
                  return-object
                  @change="componentChange($event)"
                  :readonly="disableAdd"
                ></v-autocomplete>
              </v-col>
              <v-col md="12" class="pb-0 pt-0">
                <v-switch
                  v-model="detail.fixValue"
                  inset
                  color="success"
                  value
                  input-value="false"
                 :label="$t('fixed_value')"
                  :readonly="disableAdd"
                ></v-switch>
              </v-col>
              <v-col md="12" class="pb-0 pt-0" v-if="!detail.fixValue">
                <v-textarea
                  :label="$t('formula')"
                  rows="1"
                  auto-grow
                  v-model="detail.formula"
                  required
                  class="sae-required"
                  :readonly="disableAdd"
                  append-icon="mdi-function"
                  @click:append="formulaDialog = true"
                  @click="showFormulaDialog"
                  :rules="rules3a"
                ></v-textarea>
              </v-col>
              <v-col md="12" class="pb-0 pt-0" v-if="detail.fixValue">
                <v-text-field
                  v-if="tab==1"
                  type="text"
                 :label="$t('amount')"
                  v-model="detail.amount"
                  v-mask="mask"
                  :rules="[...rules3, validator.alfaNumberNotRequired]"
                  required
                  class="sae-required"
                  :readonly="disableAdd"
                ></v-text-field>
              </v-col>
              <!-- <v-col md="12" class="pb-0 pt-0">
                <v-autocomplete
                  v-model="detail.type"
                  :items="typeList"
                  hide-no-data
                  hide-selected
                  item-text="name"
                  item-value="id"
                  label="Type"
                  required
                  :rules="rules2"
                  class="sae-required"
                  :readonly="disableAdd"
                ></v-autocomplete>
              </v-col>
              <v-col md="12" class="pb-0 pt-0">
                <v-autocomplete
                  v-model="detail.currency"
                  :items="currencyList"
                  hide-no-data
                  hide-selected
                  item-text="name"
                  item-value="id"
                  label="Currency"
                  required
                  :rules="rules5"
                  class="sae-required"
                  :readonly="disableAdd"
                ></v-autocomplete>
              </v-col> -->
              <v-col md="12" class="pb-0 pt-0">
                <v-textarea
                  :label="$t('notes')"
                  rows="1"
                  auto-grow
                  v-model="detail.note"
                  :readonly="disableAdd"
                  :rules="[validator.alfaNumberNotRequired]"
                ></v-textarea>
              </v-col>
              <v-col md="6" v-if="tab == 1">
                <v-text-field
                  :value="dateFormatted(detail.startDate)"
                  :label="$t('start_date')"
                  prepend-icon="mdi-calendar"
                  readonly
                  color="primary"
                  :rules="rules"
                  required
                  class="sae-required"
                  v-if="disableAdd"
                ></v-text-field>
                <v-menu
                  ref="menu"
                  v-model="menuStart"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                  v-else
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      :value="dateFormatted(detail.startDate)"
                     :label="$t('start_date')"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-on="on"
                      color="primary"
                      :rules="rules"
                      required
                      class="sae-required"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="detail.startDate"
                    @change="onStartDateChange"
                    no-title
                    scrollable
                    :locale="$t('locale')"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col md="6" class="pb-0" v-if="tab == 1">
                <v-text-field
                  :value="dateFormatted(detail.endDate)"
                 :label="$t('end_date')"
                  prepend-icon="mdi-calendar"
                  readonly
                  color="primary"
                  v-if="disableAdd"
                ></v-text-field>
                <v-menu
                  ref="menu"
                  v-model="menuEnd"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                  v-else
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      :value="dateFormatted(detail.endDate)"
                     :label="$t('end_date')"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-on="on"
                      color="primary"
                      clearable
                      @click:clear="clearValue('endDate')"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="detail.endDate"
                    @change="onEndDateChange"
                    no-title
                    scrollable
                    :locale="$t('locale')"
                    :min="detail.startDate"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col md="12" class="text-center" v-if="!disableAdd">
                <v-btn plain class="ma-2 primary--text" @click="tab = 0">{{$t('cancel')}}</v-btn>
                <v-btn
                  color="primary"
                  class="ma-2"
                  @click="saveOrUpdate(detail)"
                  :disabled="!valid"
                  :loading="loading"
                >{{$t('save')}}</v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </v-form>
</template>

<script>
import moment from 'moment'
import FormulaGenerator from './FormulaGenerator.vue'

export default {
  props: ['userId', 'employeeSalary', 'loadData', 'disableAdd', 'showCloseButton'],
  components: {
    FormulaGenerator
  },
  name: "Address-List",
  data() {
    return {
      mask: null,
      headers: [
        { text: "No", value: "no" },
        { text: this.$i18n.t('component'), value: "componentName"},
        // { text: "Currency", value: "currency" },
        { text: this.$i18n.t('start_date'), value: "startDate" },
        { text: this.$i18n.t('end_date'), value: "endDate" },
        { text: this.$i18n.t('action'), value: "action" },
      ],
      tab: 0,
      typeList: [
        { id: 1, name: this.$i18n.t('irregular') },
        { id: 2, name: this.$i18n.t('regular') },
        { id: 3, name: this.$i18n.t('daily') },
      ],
      currencyList: [
        { id: 'IDR', name: 'IDR' },
        { id: 'USD', name: 'USD' },
      ],
      goupByList: [
        { id: 1, name: 'Ketenagakerjaan' },
        { id: 2, name: 'Kesehatan' },
      ],
      componentList: [],
      rules: [(v) => !!v || this.$i18n.t('required')],
      rules2: [(value) => (value == 0 ? false || this.$i18n.t('required') : value ? value > 0 : !!value || this.$i18n.t('required'))],
      rules3: [v => !!v || this.$i18n.t('required'), v => /^[0-9\-.,]+$/.test(v) || 'Only accept numbers', v => (v || '' ).length <= 14 || '11 Char Max'],
      rules3a: [
        v => /^[+/*\- ()<>%.,0-9a-zA-Z]+$/.test(v) || 'This field only accept basic arithmetic operations'
      ],
      rules5: [(value) => (value ? value.length == 0 ? false || this.$i18n.t('required') : true : false)],
      validator: this.$store.state.validator,
      baseUrl: this.$store.state.baseUrl,
      valid: false,
      formData: [],
      userIdLogin: this.$store.getters.user.id,
      loading: false,
      menuStart: null,
      menuEnd: null,
      isEdit: false,
      detail: { users: [], startDate: moment().locale(this.$i18n.t('lang')).format('YYYY-MM-DD'), fixValue: false },
      showAll: false,

      formulaDialog: false,
      firstLoadFormula: true,
      deleteDialog: false,
      page: 1,
    }
  },
  methods: {
    clearValue(value) {
      this.detail[value] = null
    },
    setPage(page) {
      this.page = page
    },
    deleteItem() {
      this.deleteDialog = true;
    },
    setFormula(event) {
      this.detail.formula = event
      this.formulaDialog = false
      setTimeout(() => {
        this.firstLoadFormula = true
      }, 1000);
    },
    closeFormulaDialog() {
      this.formulaDialog = false
      setTimeout(() => {
        this.firstLoadFormula = true
      }, 1000);
    },
    showFormulaDialog() {
      if (this.firstLoadFormula) {
        this.firstLoadFormula = false
        this.formulaDialog = true
      }
    },
    close() {
      this.$emit('close', true)
    },
    add() {
      this.isEdit = false
      setTimeout(() => {
        this.detail = { users: [this.userId], startDate: null, fixValue: false, amount: null }
      }, 50);
      this.tab = 1
    },
    seeDetail(item) {
      this.isEdit = true
      this.detail = Object.assign({ users: [], fixValue: false }, item)
      this.detail.users = [this.userId]
      this.tab = 1
    },
    onStartDateChange() {
      this.menuStart = false;
      if (this.detail.endDate) this.detail.endDate = this.detail.startDate
    },
    onEndDateChange() {
      this.menuEnd = false;
    },
    dateFormatted(date) {
      if (date) return moment(date).locale(this.$i18n.t('lang')).format("Do MMMM YYYY");
      return null
    },
    componentChange(value) {
      this.detail.componentId = value.id
      this.detail.formula = value.formula
      this.detail.calculateMethod = value.calculateMethod
      this.detail.amount = value.amount
      this.detail.fixValue = value.fixValue
    },
    costumHeader(actionId, action) {
      return { headers: { actionId, action } }
    },
    showMessage(type, msg) {
      this.$store.dispatch('nShowMessage', { type, msg })
    },
    formatTime(date) {
      return moment(date).locale(this.$i18n.t('lang')).format("Do MMMM YYYY")
    },
    async getComponentPayroll() {
      try {
        this.loading = true
        const result = await this.$store.dispatch('getPayrollComponent', { status: 1, positionOnly: 0 })
        this.loading = false
        return result
      } catch (e) {
        this.loading = false
        // eslint-disable-next-line no-console
        console.error(e.message)
        return []
      }
    },
    async saveOrUpdate(data) {
      if (this.isEdit) {
        this.editComponent(data)
      } else {
        this.saveComponent(data)
      }
    },
    async saveComponent(data) {
      await this.beforeSave()
      const body = { ...data, amount: parseInt(data.amount), fixValue: data.fixValue ? true : false }
      this.loading = true
      const result = await this.$store.dispatch('saveEmployeeSalary', body)
      if (result == true) {
        this.showMessage('success', this.$i18n.t('alert_save'))
        this.refreshData()
        this.$emit('reload', true)
        this.tab = 0
      }
      this.loading = false
      await this.afterSave()
    },
    async editComponent(data) {
      await this.beforeSave()
      const body = { ...data, amount: parseInt(data.amount), fixValue: data.fixValue ? true : false }
      this.loading = true
      const result = await this.$store.dispatch('editEmployeeSalary', body)
      this.loading = false
      if (result == true) {
        this.showMessage('success', this.$i18n.t('alert_save'))
        this.refreshData()
        this.$emit('reload', true)
        this.tab = 0
      }
      await this.afterSave()
    },
    async deleteComponent(data) {
      this.loading = true
      const result = await this.$store.dispatch('deleteEmployeeSalary', data)
      this.loading = false
      if (result) {
        this.showMessage('success', 'Data Deleted')
        this.deleteDialog = false
        this.tab = 0
        this.refreshData()
      }
    },
    async getComponentActiveOnly() {
      this.loading = true
      const result = await this.$store.dispatch('getEmployeeSalaryActive', { userId: this.userId })
      this.loading = false
      return result
    },
    async getComponent() {
      this.loading = true
      const result = await this.$store.dispatch('getEmployeeSalary', { userId: this.userId })
      this.loading = false
      return result
    },
    async refreshData() {
      if (this.showAll) {
        this.formData = await this.getComponent()
      } else {
        this.formData = await this.getComponentActiveOnly()
      }
      // this.detail = { users: [], startDate: moment().format('YYYY-MM-DD'), fixValue: false }
    },
    async beforeSave() {
      this.mask = await this.$store.dispatch('getNumberMaskFormat', false)
    },
    async afterSave() {
      this.mask = await this.$store.dispatch('getNumberMaskFormat')
    },
  },
  async beforeMount() {
    this.mask = await this.$store.dispatch('getNumberMaskFormat')
  },
  async created() {
    this.refreshData()
    this.componentList = await this.getComponentPayroll()
    this.detail.users = [this.userId]
  },
  computed: {
    addAllUser() {
      return this.detail.users ? this.detail.users.length === this.userList.length : false;
    },
    addAll() {
      return this.detail.users ? this.detail.users.length > 0 && !this.addAllUser : false;
    },
    editAllUser() {
      return this.detail.users ? this.detail.users.length === this.userList.length : false;
    },
    editAll() {
      return this.detail.users ? this.detail.users.length > 0 && !this.editAllUser : false;
    },
    icon() {
      if (this.addAllUser) return "mdi-close-box";
      if (this.addAll) return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    },
    iconEdit() {
      if (this.editAllUser) return "mdi-close-box";
      if (this.editAll) return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    },
  },
  watch: {
    employeeSalary() {
      this.refreshData()
    },
    userId() {
      this.refreshData()
      this.tab = 0
    },
    detail() {
      if (this.$refs.form && !this.isEdit) {
        this.$refs.form.reset();
      }
    }
  }
}
</script>
<style scoped>
.sae-grey {
  background: #7c8a963d;
  line-height: 35px;
  cursor: pointer;
}
</style>